import Counter from "../../features/counter/Counter";

export const EnhancedCounter = ({ setReferencePopup, pathname, search, forwardRef }) => {
    return (
        <div>
            <h2>Enhanced Counter</h2>
            <Counter
                pathname={pathname}
                search={search}
                setReferencePopup={setReferencePopup}
                ref={forwardRef}
            />
        </div>
    );
};
